var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.778 4c1.195 0 2.25 1.055 2.25 2.25v1.406c5.133.985 9 5.555 9 10.969v1.828c0 3.164 1.055 6.258 3.023 8.789l1.055 1.266c.422.562.492 1.265.211 1.828a1.64 1.64 0 01-1.477.914H5.716c-.704 0-1.266-.352-1.547-.914-.281-.563-.211-1.266.21-1.828l1.055-1.266c1.97-2.531 3.094-5.625 3.094-8.789v-1.828c0-5.414 3.867-9.984 9-10.969V6.25c0-1.195.985-2.25 2.25-2.25zm0 6.75c-4.36 0-7.875 3.586-7.875 7.875v1.828c0 3.375-.984 6.61-2.812 9.422h21.304c-1.828-2.813-2.742-6.047-2.742-9.422v-1.828c0-4.29-3.586-7.875-7.875-7.875zm4.5 24.75c0 1.195-.492 2.39-1.336 3.234-.844.844-1.969 1.266-3.164 1.266s-2.39-.422-3.234-1.266c-.844-.843-1.266-2.039-1.266-3.234h9z",
    fill: "#111"
  })));
}
export default SvgBell;